import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

import { axios } from 'lib';

const createLevelStructure = (resource, id, values) => {
  return axios.post(`/api/${resource}/${id}/setup/level_structures`, values);
};

export const useCreateLevelStructure = (resource, id, onSuccess) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: (values) => createLevelStructure(resource, id, values),
    onSuccess: () => {
      enqueueSnackbar('Level structure successfully added', { variant: 'success' });
      onSuccess();
    },
    onError: (error) => {
      enqueueSnackbar(
        error?.response?.data?.description || error?.message || 'Some error occured',
        {
          variant: 'error',
        }
      );
    },
  });
};
